import InstallmentsPlanSelectorOvContainer from './InstallmentsPlanSelectorOvContainer';

export default InstallmentsPlanSelectorOvContainer;
